// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import InternalButtonDropdown from '../../button-dropdown/internal';
import { useInternalI18n } from '../../i18n/context';
export function SortMenu({ inSort, isSortedAscending, isSortedDescending, i18nStrings, ariaLabel, ariaDescribedby, onAction, }) {
    var _a, _b, _c, _d, _e, _f, _g;
    const i18n = useInternalI18n('table');
    const items = [
        {
            id: 'sort-ascending',
            itemType: 'checkbox',
            text: (_a = i18n('i18nStrings.sortDropdownSortAscending', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.sortDropdownSortAscending)) !== null && _a !== void 0 ? _a : '',
            checked: isSortedAscending,
        },
        {
            id: 'sort-descending',
            itemType: 'checkbox',
            text: (_b = i18n('i18nStrings.sortDropdownSortDescending', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.sortDropdownSortDescending)) !== null && _b !== void 0 ? _b : '',
            checked: isSortedDescending,
        },
        {
            id: 'multi-column-sort-group',
            itemType: 'group',
            text: (_c = i18n('i18nStrings.sortDropdownMultiColumnSortGroup', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.sortDropdownMultiColumnSortGroup)) !== null && _c !== void 0 ? _c : '',
            items: [
                {
                    id: 'add-to-sort-ascending',
                    text: (_d = i18n('i18nStrings.sortDropdownAddToSortAscending', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.sortDropdownAddToSortAscending)) !== null && _d !== void 0 ? _d : '',
                    disabled: inSort,
                    disabledReason: i18n('i18nStrings.sortDropdownAddToSortDisabledReason', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.sortDropdownAddToSortDisabledReason),
                },
                {
                    id: 'add-to-sort-descending',
                    text: (_e = i18n('i18nStrings.sortDropdownAddToSortDescending', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.sortDropdownAddToSortDescending)) !== null && _e !== void 0 ? _e : '',
                    disabled: inSort,
                    disabledReason: i18n('i18nStrings.sortDropdownAddToSortDisabledReason', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.sortDropdownAddToSortDisabledReason),
                },
                {
                    id: 'remove-from-sort',
                    text: (_f = i18n('i18nStrings.sortDropdownRemoveFromSort', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.sortDropdownRemoveFromSort)) !== null && _f !== void 0 ? _f : '',
                    disabled: !inSort,
                    disabledReason: i18n('i18nStrings.sortDropdownRemoveFromSortDisabledReason', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.sortDropdownRemoveFromSortDisabledReason),
                },
            ],
        },
    ];
    return (React.createElement(InternalButtonDropdown, { items: items, variant: "icon", compactTrigger: true, expandToViewport: true, ariaLabel: (_g = i18n('ariaLabels.sortMenuTriggerLabel', ariaLabel)) !== null && _g !== void 0 ? _g : '', ariaDescribedby: ariaDescribedby, onItemClick: ({ detail }) => onAction(detail.id) }));
}
//# sourceMappingURL=sort-menu.js.map